import { ISolicitudExtenderModel } from "../interfaces/solicitud/ISolicitudExtenderModel";

export class SolicitudExtenderModel implements ISolicitudExtenderModel {
    idSolicitud : number;
    fechaFinAnterior: Date;
    fechaFinNuevo?: Date;
    comentarios: string;

    constructor(){
        this.idSolicitud = 0;
        this.fechaFinAnterior = new Date();
        // this.fechaFinNuevo = new Date();
        this.comentarios = '';
    }
}